const twoDigit = (value: number): string => String(value).padStart(2, "0");

export const toDateTimeLocalInputValue = (date: Date): string => {
  const year = date.getFullYear();
  const month = twoDigit(date.getMonth() + 1);
  const day = twoDigit(date.getDate());
  const hour = twoDigit(date.getHours());
  const minute = twoDigit(date.getMinutes());
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export const currentDateTimeLocalInputValue = (): string => {
  return toDateTimeLocalInputValue(new Date());
};

export const dateTimeLocalToIso = (value: string): string | null => {
  const normalized = value.trim();
  if (!normalized) return null;
  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toISOString();
};

export const isoToDateTimeLocalInputValue = (value: string | null | undefined): string => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return toDateTimeLocalInputValue(parsed);
};
